module.exports = __webpack_public_path__ + "assets/img/question_small.59487732.svg";